/**
 * Returns object from url parameters
 *
 * @param {string} url window.location.search
 * @param {array} paramsToSkip
 * @return {object}
 */
export default function deparamUrl(url, paramsToSkip = []) {
    const urlObj = {};

    // remove question mark from the beginning of the string
    const queryString = url.indexOf('?') === 0 ? url.substr(1) : url;

    queryString.split('&').forEach((param) => {
        const [key, value] = param.split('=');
        const hasValue = typeof value !== 'undefined' && value !== '';

        // skip if value undefined or empty string
        if (hasValue && !paramsToSkip.includes(key)) {
            let decodedUri;

            try {
                decodedUri = decodeURIComponent(value.replaceAll(/\+/g, ' '));
            } catch (error) {
                decodedUri = null;
            }

            if (decodedUri) {
                let decodedKey;

                try {
                    decodedKey = decodeURIComponent(key);
                } catch (error) {}

                if (decodedKey) {
                    urlObj[decodedKey] = decodedUri;
                }
            }
        }
    });

    return urlObj;
}
